/**
 * Generato automaticamente.
 * OpenAPI
 */

export type GetTipiDomandaTipoPubblicazione =
  (typeof GetTipiDomandaTipoPubblicazione)[keyof typeof GetTipiDomandaTipoPubblicazione];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTipiDomandaTipoPubblicazione = {
  PUBBLICATA: 'PUBBLICATA',
  IN_COLLAUDO: 'IN_COLLAUDO',
} as const;
